import PropTypes from 'prop-types';
import NavBarTabletDropdown from './NavBarTabletDropdown';
import { Component } from 'react';

class NavBarTablet extends Component {
	static onClickButton(e) {
		e.preventDefault();
	}

	render() {
		return (
			<ul className="navigation__list--usercentral">
				<li id="navbar-tablet-dropdown" className="navigation__item -margin-icon -collapsed-visible navbar-tablet__dropdown">
					<div className="navigation__link">
						<a className="js-dropdown-toggle navigation__link" href="#" onClick={NavBarTablet.onClickButton}>
							<i className="navigation__icon tablet-nav -icon-hamburger-line" />
						</a>
						<NavBarTabletDropdown navLinks={this.props.navLinks} voiceCallLabel={this.props.voiceCallLabel} />
					</div>
				</li>
			</ul>
		);
	}
}

NavBarTablet.propTypes = {
	navLinks: PropTypes.arrayOf(
		PropTypes.shape({
			caption: PropTypes.string,
			link: PropTypes.string,
			isHighlighted: PropTypes.bool,
			isNew: PropTypes.bool,
			hasSale: PropTypes.bool,
			subNavigation: PropTypes.array,
		}),
	),
	voiceCallLabel: PropTypes.string,
};

export default NavBarTablet;
